@switch (columnName) {
  @case ('messageRecipientsExpand__hidden') {
    <span class="message-recipients-expand-cell">
      @if (messageRow?.recipientDetailRows?.length) {
        <mat-icon>expand_more</mat-icon>
      }
    </span>
  }
  @case ('sentAt') {
    {{ messageRow?.sentAt ? (messageRow?.sentAt | date: dateTimeFormat) : '-' }}
  }
  @case ('sentByName') {
    {{ messageRow?.sentByName || '-' }}
  }
  @case ('type') {
    <span class="message-type">
      @if (messageRow?.sms) {
        <span>{{ 'sms' | translate }}</span>
      }
      @if (messageRow?.sms && messageRow?.email) {
        <span>+</span>
      }
      @if (messageRow?.email) {
        <span>{{ 'email' | translate }}</span>
      }
      @if (!messageRow?.sms && !messageRow?.email) {
        <span>-</span>
      }
    </span>
  }
  @case ('recipient') {
    @if (recipientDetailRow; as detail) {
      @if (detail.nextOfKinRecipientLabel) {
        <div class="stacked-list">
          <div class="stacked-list__item">{{ detail.nextOfKinRecipientLabel }}</div>
          <div class="stacked-list__item text-secondary">
            {{ 'user' | translate }}: {{ detail.recipientUserLabel }}
          </div>
        </div>
      } @else {
        {{ detail.recipientLabel }}
      }
    } @else {
      -
    }
  }
  @case ('subject') {
    <app-text-overflow-label [text]="messageRow?.subject || '-'"></app-text-overflow-label>
  }
  @case ('content') {
    <app-text-overflow-label [text]="messageRow?.content || '-'"></app-text-overflow-label>
  }
  @case ('deliveryStatus') {
    @if (recipientDetailRow; as detail) {
      @if (detail.deliveryChannelLines.length) {
        <div class="stacked-list">
          @for (channel of detail.deliveryChannelLines; track $index) {
            <div class="stacked-list__item">
              <div>
                {{ channel.channelTranslationKey | translate }}{{ channel.contactDisplay }}:
                {{ channel.statusTranslationKey | translate }}
                @if (channel.statusDetail) {
                  <span> — {{ channel.statusDetail }}</span>
                }
              </div>
              <div class="text-secondary">
                {{ channel.providerTranslationKey | translate }}
              </div>
            </div>
          }
        </div>
      } @else {
        {{ 'messageDeliveryUnknown' | translate }}
      }
    } @else if (messageRow; as row) {
      @if (row.deliveryStatusCounts.length) {
        <div class="stacked-list stacked-list--compact">
          @for (item of row.deliveryStatusCounts; track item.status) {
            <div class="stacked-list__item">
              {{ item.statusTranslationKey | translate }}: {{ item.count }}
            </div>
          }
        </div>
      } @else {
        -
      }
    } @else {
      -
    }
  }
  @case ('sentToNextOfKin') {
    @if (recipientDetailRow; as detail) {
      {{ (detail.hasNextOfKinDeliveries ? 'yes' : 'no') | translate }}
    } @else if (messageRow; as row) {
      @if (row.hasMultipleNextOfKinPeople) {
        {{ 'multipleNextOfKinPeopleExpandForDetails' | translate }}
      } @else if (row.hasNextOfKinDeliveries) {
        <div class="stacked-list">
          @for (group of row.nextOfKinDeliveryGroups; track group.key) {
            <div class="delivery-group">
              <div class="delivery-group__name">{{ group.recipientLabel }}</div>
              @for (channel of group.channels; track $index) {
                <div class="delivery-group__channel text-secondary">
                  {{ channel.channelTranslationKey | translate }}{{ channel.contactDisplay }}:
                  {{ channel.statusTranslationKey | translate }}
                </div>
              }
            </div>
          }
        </div>
      } @else {
        {{ (row.sentToNextOfKin ? 'yes' : 'no') | translate }}
      }
    }
  }
  @case ('smsSegmentCount') {
    {{ messageRow?.smsSegmentCount ?? '-' }}
  }
  @default {
    {{ defaultValue }}
  }
}
